import { Pipe, PipeTransform } from '@angular/core';
import { UserDetail, UserInfo } from '@ca/core/models';
import { FullNamePipe } from '../full-name/full-name.pipe';

@Pipe({
    name: 'fullNameWithEmail',
})
export class FullNameWithEmailPipe implements PipeTransform {
    constructor(private fullNamePipe: FullNamePipe) {}

    transform(userInfo?: UserInfo | UserDetail): string {
        const fullName = this.fullNamePipe.transform(userInfo);
        if (fullName === '') {
            return '';
        }
        if (userInfo != null && userInfo.email != null) {
            return `${fullName} (${userInfo.email})`;
        } else {
            return fullName;
        }
    }
}
